import vuexModule from "./vuex-module";

export default {hooks:undefined,vuexModule,vuexPlugin:undefined}
